// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 923 ? "8e095c31" : chunkId) + "." + {"9":"2d1e15138c8355b8","521":"b766ef233d6cc968","923":"ed592bafc9bb191c","964":"d602607b7a7a70bc"}[chunkId] + ".js";
};